import { AttributeConfigurationDc, PostgresLayerServiceConfigurationDc } from "@evergis/api";
import { LayerInfo } from "../../../interfaces/resourceInfo";
import { LayerAttribute } from "../../../components/Dialogs/EditResource/components/Layer/LayerAttributeItem";
import { getAttributesConfiguration } from "./getAttributesConfiguration";
import { StyleProxy } from "../classification/StyleProxy";

const toAttributeConfiguration = ({ type, deleted, id, ...layerAttribute }: LayerAttribute): AttributeConfigurationDc =>
  layerAttribute;

export function createLayerConfiguration(
  layer: LayerInfo,
  attributes: LayerAttribute[],
  titleAttribute: string,
): PostgresLayerServiceConfigurationDc {
  const { configuration, style, name } = layer || {};
  let layerAttributesConfig: PostgresLayerServiceConfigurationDc = {
    attributesConfiguration: getAttributesConfiguration(layer),
    name,
  };

  if (attributes && style) {
    const classificationResetAttributes = attributes
      .filter(({ resetClassification, deleted }) => resetClassification || deleted)
      .map(({ attributeName }) => attributeName);

    for (const attributeToReset of classificationResetAttributes) {
      style.classificationManager.remove(({ attribute }) => attribute === attributeToReset);
    }
  }

  if (attributes && layer.configuration) {
    layerAttributesConfig = {
      ...configuration,
      attributesConfiguration: {
        ...configuration.attributesConfiguration,
        attributes: attributes.filter(({ deleted }) => !deleted).map(toAttributeConfiguration),
        titleAttribute,
      },
    };
  }

  return {
    ...layerAttributesConfig,
    name,
    style: style && new StyleProxy(style).serialize(),
  };
}
